import guidGenerator from "uuid/v4"
import chroma from "chroma-js"

const toggleFullScreen = () => {
  let doc = window.document
  let docEl = doc.documentElement

  let requestFullScreen =
    docEl.requestFullscreen ||
    docEl.mozRequestFullScreen ||
    docEl.webkitRequestFullScreen ||
    docEl.msRequestFullscreen
  let cancelFullScreen =
    doc.exitFullscreen ||
    doc.mozCancelFullScreen ||
    doc.webkitExitFullscreen ||
    doc.msExitFullscreen

  if (
    !doc.fullscreenElement &&
    !doc.mozFullScreenElement &&
    !doc.webkitFullscreenElement &&
    !doc.msFullscreenElement
  ) {
    requestFullScreen.call(docEl)
  } else {
    cancelFullScreen.call(doc)
  }
}

function stringToLink(toConvert) {
  return toConvert.toLowerCase().replace(new RegExp(" ", "g"), "-")
}

function linkToString(toConvert) {
  var str = toConvert.replace(new RegExp("-", "g"), " ")

  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match) {
    if (+match === 0) return " " // or if (/\s+/.test(match)) for white spaces
    return match.toUpperCase()
  })
}

function removeWhitespace(string) {
  return string.replace(/\s/g, "")
}

function generateGuid() {
  return guidGenerator()
}

/**
 *
 * @param baseColour
 * @returns {*}
 */
function generateColourPalette(baseColour) {
  return chroma
    .scale([baseColour, chroma(baseColour).darken(2.6)])
    .mode("lch")
    .colors(8)
}

export default {
  toggleFullScreen,
  stringToLink,
  linkToString,
  generateGuid,
  generateColourPalette,
  removeWhitespace,
  mutateWithFile,
  getDate,
  uploadTaskFile,
  addDays,
  isObject,
  getUserName
}

/**
 *
 * @param search
 * @param replacement
 * @returns {string}
 */
String.prototype.replaceAll = function(search, replacement) {
  let target = this
  return target.replace(new RegExp(search, "g"), replacement)
}
/**
 *
 * @param value
 * @returns {boolean}
 */
String.prototype.includesLowerCase = function(value) {
  return !value || this.toLowerCase().includes(value.toLowerCase())
}

/**
 *
 * @param oldDate
 * @returns {string|*}
 */
function getDate(oldDate) {
  if (!oldDate) return oldDate
  var date = new Date(oldDate)
  var day = date.getDate() // yields date
  var month = date.getMonth() + 1 // yields month (add one as '.getMonth()' is zero indexed)
  var year = date.getFullYear() // yields year

  // After this construct a string with the above results as below
  return year + "/" + month + "/" + day
}

/**
 *
 * @param mutation the GQL mutation from .gql file
 * @param file the file you want to send - bound with v-model to input el
 * @param variables optional variables to pass to your mutation
 * @returns {Promise<any>}
 */
async function mutateWithFile(mutation, file, variables) {
  var data = new FormData()

  data.append("files[]", file, file.name)

  data.append("query", mutation)
  data.append("variables", JSON.stringify(variables))

  var postSettings = {
    method: "POST",
    body: data
  }

  const resp = await fetch(process.env.VUE_APP_GRAPHQL_HTTP, postSettings)
  return await resp.json()
}

/**
 *
 * @param file
 * @param taskId
 * @returns {Promise<any>}
 */
async function uploadTaskFile(file, taskId) {
  var data = new FormData()

  data.append("files[]", file, file.name)

  data.append("taskId", taskId)

  var postSettings = {
    method: "POST",
    body: data
  }

  const resp = await fetch(process.env.VUE_APP_FILE_UPLOAD_HTTPS, postSettings)
  return await resp.json()
}

Array.prototype.unique = function() {
  var a = this.concat()
  for (var i = 0; i < a.length; ++i) {
    for (var j = i + 1; j < a.length; ++j) {
      if (a[i] === a[j]) a.splice(j--, 1)
    }
  }

  return a
}

String.prototype.seperateByCapitalLetter = function() {
  return this.replace(/([A-Z])/g, " $1").trim()
}
//TODO
Array.prototype.reduceBy = function(func) {
  return this?.reduce((a, c) => {
    a.total = a.total || 0
    a.total += func(c)
    return { ...a }
  })
}

Date.prototype.asGMT = function() {
  let gmtDate = new Date(`${this} GMT`)
  //Safari
  if (gmtDate == "Invalid Date")
    gmtDate = new Date(this.setHours(this.getHours() + 2))

  return gmtDate
}

/**
 * Sort any array of objects by specified key in ascending order
 * @param func
 * @returns {this}
 */
Array.prototype.sortBy = function(func) {
  return this?.sort((a, b) => (func(a) > func(b) ? 1 : -1))
}

/**
 * Sort any array of objects by specified key in descending order
 * @param func
 * @returns {this}
 */
Array.prototype.sortByDescending = function(func) {
  return this?.sort((a, b) => (func(a) > func(b) ? -1 : 1))
}

/**
 * Removes Unassigned user from array of users
 * @returns {*[]}
 */
Array.prototype.removeUnassigned = function() {
  //Removes unassigned user
  return this?.filter(x => !x.id.includesLowerCase("**unass"))
}

function addDays(dateString, days) {
  var d = new Date(
    new Date(dateString).setDate(new Date(dateString).getDate() + days ?? 0)
  )
  d.setMinutes(0)
  d.setHours(24)
  d.setSeconds(0)

  return d
}

function isObject(yourVariable) {
  return typeof yourVariable === "object" && yourVariable !== null
}

function getUserName(user) {
  return `${user.firstName} ${user.lastName.substr(0, 1).toUpperCase()}`
}
